import { Hash, type persistence } from "borogove";
import { invoke, Resource } from "@tauri-apps/api/core";

export class MediaStoreTauri implements persistence.MediaStore {
	// Instead of using KV we store data on the filesystem because the rust
	// implementation doesn't have access to this KV store
	setKV(value: persistence.KeyValueStore) {
		void value;
	}

	async storeMedia(mime: string, source: ReadableStream<Uint8Array>) {
		const upload = new Resource(await invoke<number>("begin_media", { mime }));
		try {
			await source.pipeTo(
				new WritableStream<Uint8Array>({
					write(chunk) {
						return invoke("write_media", chunk, {
							headers: { "X-Media-Id": String(upload.rid) },
						});
					},
				}),
			);
		} catch (error) {
			await upload.close();
			throw error;
		}
		return await invoke<string>("finish_media", { rid: upload.rid });
	}

	hasMedia(hash: Hash) {
		return invoke<string | null>("has_media", {
			algorithm: hash.algorithm,
			hex: hash.toHex(),
		});
	}

	async removeMedia(algorithm: string, bytes: ArrayBuffer) {
		await invoke("remove_media", {
			algorithm,
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array/toHex
			hex: Array.from(new Uint8Array(bytes), (b) =>
				b.toString(16).padStart(2, "0"),
			).join(""),
		});
		return true;
	}
}
